
import React from 'react';
import { DragOverlay } from '@dnd-kit/core';
import { ScrollArea } from '@/components/ui/scroll-area';
import { PipelineColumn as PipelineColumnType, Prospect } from '@/types/pipeline';
import PipelineColumnComponent from './PipelineColumn';
import PipelineCard from './PipelineCard';

interface PipelineBoardContentProps {
  columns: PipelineColumnType[];
  activeProspect: Prospect | null;
  onProspectClick: (prospect: Prospect) => void;
}

const PipelineBoardContent = ({ 
  columns, 
  activeProspect, 
  onProspectClick 
}: PipelineBoardContentProps) => {
  return (
    <>
      <ScrollArea orientation="horizontal" className="pb-6">
        <div className="flex gap-6 min-w-max">
          {columns.map((column) => (
            <PipelineColumnComponent
              key={column.id}
              column={column}
              onProspectClick={onProspectClick}
            />
          ))}
        </div>
      </ScrollArea>

      <DragOverlay>
        {activeProspect ? (
          <PipelineCard
            prospect={activeProspect}
            onClick={() => {}}
          />
        ) : null}
      </DragOverlay>
    </>
  );
};

export default PipelineBoardContent;
